import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Nonacurbaniaonrentinpune() {



    const cardData =
    {
        keyword: 'Non AC Urbania on Rent Pune',
        heading: 'Urbania on rent in pune: Non AC Urbania on Rent Pune',
        headingDescription: 'Urbania On Rent in Pune provides reliable and cost-effective Non AC Urbania on Rent in Pune for corporate teams, families, tourists, and group travel needs across the city. Our well-maintained Force Urbania non-AC vehicles offer spacious seating, smooth performance, and comfortable travel, making them ideal for short-distance trips, local travel, factory visits, weddings, sightseeing, and outstation journeys from Pune. With experienced chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe and budget-friendly travel experience. Backed by 24/7 booking support, punctual service, and transparent pricing, Urbania On Rent in Pune stands out as the trusted choice for affordable non-AC Urbania hire in Pune.',

        top: 'Top Places to Visit in Pune with Urbania on rent in pune',


        "topPlaces": [
            {
                "title": "Shaniwar Wada",
                "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic historical landmark and a symbol of Maratha power. Once the administrative seat of Bajirao I, the fort complex featured grand halls, fountains, and courtyards. Although a major fire destroyed much of the structure, the massive stone walls, gates like the Delhi Darwaza, and remaining ruins still reflect its former grandeur. The evening light-and-sound show vividly narrates Maratha history, making it a must-visit heritage attraction."
            },
            {
                "title": "Aga Khan Palace",
                "description": "Aga Khan Palace is a significant monument linked to India’s freedom struggle. Built in 1892, it served as a prison for Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai during the Quit India Movement. Today, it houses a museum displaying photographs, letters, and personal belongings of Gandhi. Surrounded by lush gardens and Italian-style arches, the palace offers a peaceful yet historically powerful experience."
            },
            {
                "title": "Sinhagad Fort",
                "description": "Sinhagad Fort stands atop a rugged hill in the Sahyadri range and is renowned for the heroic sacrifice of Tanaji Malusare in 1670. The fort offers breathtaking panoramic views of Pune and surrounding valleys. Visitors can trek or drive to explore ancient ramparts, memorials, and gates. Local food stalls serving traditional pithla-bhakri add to the authentic experience, making it a favorite spot for history lovers and adventure seekers."
            },
            {
                "title": "Dagdusheth Halwai Ganpati Temple",
                "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered Ganesh temple. The beautifully adorned idol, decorated with gold ornaments, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the heart of grand celebrations with processions and cultural events. The temple trust is also known for its social and charitable initiatives, making it both a spiritual and cultural landmark."
            },
            {
                "title": "Pataleshwar Cave Temple",
                "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. Despite being located in a busy area, the temple offers a calm and meditative atmosphere. The monolithic pillars, circular Nandi mandap, and ancient carvings showcase early Indian craftsmanship. It is one of Pune’s lesser-known yet spiritually rich heritage sites."
            },
            {
                "title": "Raja Dinkar Kelkar Museum",
                "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar to preserve Indian art and culture. Exhibits include musical instruments, sculptures, lamps, utensils, and traditional household items. The recreated Mastani Mahal is a major highlight. The museum offers a deep insight into India’s cultural diversity and traditional craftsmanship."
            },
            {
                "title": "Parvati Hill and Temple",
                "description": "Parvati Hill is one of Pune’s oldest heritage sites, offering panoramic city views after climbing 103 stone steps. The hilltop temple complex dates back to the Peshwa era and is dedicated to Lord Shiva and Goddess Parvati. Smaller temples and a museum enrich the visit. Sunrise and sunset views from the hill are especially popular among locals and tourists."
            },
            {
                "title": "Osho Ashram",
                "description": "Located in Koregaon Park, the Osho International Meditation Resort is a world-famous center for meditation and mindfulness. Spread across landscaped gardens, it offers meditation programs, wellness therapies, and spiritual retreats. Visitors from across the globe come here seeking inner peace, relaxation, and personal transformation, making it an international spiritual destination."
            },
            {
                "title": "Pu La Deshpande Garden",
                "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped garden. It features flowing streams, arched bridges, manicured lawns, and seasonal flowers. Ideal for morning walks, family outings, and photography, the garden blends Japanese aesthetics with Indian natural beauty, offering a serene green escape."
            },
            {
                "title": "Khadakwasla Dam",
                "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. The vast reservoir, cool breeze, and surrounding hills create a refreshing atmosphere, especially during monsoon and evenings. Street vendors selling corn and tea add local charm. It also serves as a gateway to Sinhagad Fort, making it a scenic leisure destination."
            }
        ],



"services": [
    {
      "name": "Non AC Urbania on Rent Pune",
      "description": "Non AC Urbania on Rent Pune offers practical and comfortable Urbania vehicles for city travel, family outings, and group trips without air-conditioning. Ideal for budget-conscious travelers who want reliable transportation with spacious seating, safety, and professional chauffeur services, ensuring a smooth journey across Pune."
    },
    {
      "name": "Non Air Conditioned Urbania Rental Pune",
      "description": "Non Air Conditioned Urbania Rental Pune provides dependable Urbania vehicles without AC for everyday travel, local trips, and organized group transport. Well-maintained interiors, fuel efficiency, and courteous drivers make it a convenient choice for cost-effective and reliable travel experiences."
    },
    {
      "name": "Budget Urbania Hire Pune",
      "description": "Budget Urbania Hire Pune delivers affordable non-AC Urbania vehicles for city commutes, team outings, and short-distance trips. With attention to cleanliness, vehicle safety, and punctual drivers, this service ensures travelers get value for money while maintaining comfort and convenience."
    },
    {
      "name": "Urbania Non AC Bus Hire Pune",
      "description": "Urbania Non AC Bus Hire Pune offers reliable and spacious non-air-conditioned buses suitable for group travel, tours, school trips, and corporate outings. These buses provide ample seating, safety features, and experienced drivers for a hassle-free group journey at economical rates."
    },
    {
      "name": "Affordable Non AC Urbania Pune",
      "description": "Affordable Non AC Urbania Pune provides cost-effective non-AC Urbania rentals without compromising on comfort or reliability. Ideal for budget travelers, family trips, or group outings, this service focuses on cleanliness, timely pickups, and professional driver assistance."
    },
    {
      "name": "Non AC Urbania for Outstation Pune",
      "description": "Non AC Urbania for Outstation Pune ensures safe and economical long-distance travel with experienced highway drivers and well-maintained vehicles. Perfect for intercity trips, family vacations, or small group tours where comfort and cost-efficiency are priorities."
    },
    {
      "name": "Non AC Urbania for Office Trips Pune",
      "description": "Non AC Urbania for Office Trips Pune delivers dependable transportation for daily office commutes, corporate meetings, and team outings. With professional chauffeurs, spacious seating, and prompt service, employees can enjoy stress-free travel at budget-friendly rates."
    },
    {
      "name": "Non AC Urbania for Marriage Events Pune",
      "description": "Non AC Urbania for Marriage Events Pune provides convenient and affordable transportation for weddings, guests, and family members. Vehicles are clean, reliable, and driven by courteous chauffeurs, making group travel to wedding venues smooth and economical."
    },
    {
      "name": "Economy Urbania Rental Pune",
      "description": "Economy Urbania Rental Pune focuses on providing budget-friendly non-AC Urbania vehicles for everyday travel, group tours, and corporate trips. With well-maintained interiors, fuel-efficient engines, and friendly drivers, this service combines cost savings with practical comfort."
    },
    {
      "name": "Low Cost Urbania Hire Pune",
      "description": "Low Cost Urbania Hire Pune offers highly affordable non-AC Urbania vehicles for city travel, family trips, and short-distance commutes. Prioritizing safety, reliability, and punctuality, it is an ideal option for travelers seeking budget transportation without compromising basic comfort."
    },
    {
      "name": "Chauffeur Driven Non AC Urbania Pune",
      "description": "Chauffeur Driven Non AC Urbania Pune provides stress-free travel with trained, verified drivers experienced in city and highway driving. Non-AC vehicles are well-maintained and suitable for budget-conscious travelers who want convenience, safety, and punctual service."
    },
    {
      "name": "Non AC Urbania Group Travel Pune",
      "description": "Non AC Urbania Group Travel Pune offers organized and comfortable non-AC transportation for group tours, school trips, corporate outings, and social events. With spacious seating and experienced chauffeurs, large groups can travel together economically without sacrificing safety or reliability."
    },
    {
      "name": "Best Non AC Urbania Rental Pune",
      "description": "Best Non AC Urbania Rental Pune delivers top-rated non-air-conditioned Urbania services known for reliability, vehicle quality, and customer satisfaction. Budget travelers can enjoy dependable transportation with spacious interiors, experienced drivers, and excellent service standards."
    },
    {
      "name": "Non AC Urbania Bus Hire Pune",
      "description": "Non AC Urbania Bus Hire Pune provides cost-effective non-air-conditioned buses for group travel, corporate tours, and school or college trips. These buses offer ample seating, safety features, and professional drivers to ensure smooth, reliable, and economical journeys."
    },
    {
      "name": "Value Urbania Hire Pune",
      "description": "Value Urbania Hire Pune offers highly affordable non-AC Urbania rentals for city commutes, intercity travel, and group outings. With a focus on reliability, cleanliness, and professional chauffeur service, it is an excellent choice for travelers seeking maximum value for money."
    }
  ],
  "tableData": [
    ["Non AC Urbania on Rent Pune", "Non Air Conditioned Urbania Rental Pune"],
    ["Budget Urbania Hire Pune", "Urbania Non AC Bus Hire Pune"],
    ["Affordable Non AC Urbania Pune", "Non AC Urbania for Outstation Pune"],
    ["Non AC Urbania for Office Trips Pune", "Non AC Urbania for Marriage Events Pune"],
    ["Economy Urbania Rental Pune", "Low Cost Urbania Hire Pune"],
    ["Chauffeur Driven Non AC Urbania Pune", "Non AC Urbania Group Travel Pune"],
    ["Best Non AC Urbania Rental Pune", "Non AC Urbania Bus Hire Pune"],
    ["Value Urbania Hire Pune", ""]
  ],





"whychoose": [
    {
        "WhyChooseheading": "Affordable Non AC Urbania on Rent Pune",
        "WhyChoosedescription": "Non AC Urbania on Rent Pune is a cost-effective solution for travelers looking for spacious and comfortable group travel for family trips, corporate outings, weddings, and outstation journeys."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Force Urbania Vehicles",
        "WhyChoosedescription": "Non AC Urbania on Rent Pune provides well-maintained Force Urbania vehicles with ample seating and luggage space, ensuring a smooth and hassle-free travel experience."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Non AC Urbania on Rent Pune comes with skilled drivers who are familiar with Pune routes and highways, guaranteeing safe and timely travel."
    },
    {
        "WhyChooseheading": "Transparent and Budget-Friendly Pricing",
        "WhyChoosedescription": "Choose Non AC Urbania on Rent Pune for affordable rates with no hidden charges, making group travel economical and reliable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Support",
        "WhyChoosedescription": "Non AC Urbania on Rent Pune provides round-the-clock assistance for bookings, inquiries, and last-minute travel requirements."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Non AC Urbania on Rent Pune is available for hourly rentals, full-day bookings, corporate travel, wedding transportation, and customized outstation trips."
    },
    {
        "WhyChooseheading": "Clean and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Non AC Urbania vehicles are regularly serviced and cleaned to ensure a safe, comfortable, and enjoyable journey."
    },
    {
        "WhyChooseheading": "Reliable and Punctual Service",
        "WhyChoosedescription": "Non AC Urbania on Rent Pune guarantees on-time pickups and dependable service for stress-free group travel."
    }
]
}

const faqData = [
    {
        question: 'Is Non AC Urbania on Rent Pune available for local and outstation travel?',
        answer: 'Yes, Non AC Urbania on Rent Pune can be booked for both local city travel and outstation trips, offering a comfortable and spacious travel experience.',
    },
    {
        question: 'How can I book Non AC Urbania on Rent Pune?',
        answer: 'You can book Non AC Urbania on Rent Pune via phone, WhatsApp, or online for quick and hassle-free reservations.',
    },
    {
        question: 'Why choose Non AC Urbania on Rent Pune for group travel?',
        answer: 'Non AC Urbania on Rent Pune offers spacious seating, ample luggage space, and smooth ride quality, making it ideal for family, corporate, and group travel.',
    },
    {
        question: 'Is Non AC Urbania on Rent Pune suitable for corporate and event travel?',
        answer: 'Yes, Non AC Urbania on Rent Pune is perfect for corporate trips, airport transfers, weddings, events, and business meetings.',
    },
    {
        question: 'Are drivers experienced with Non AC Urbania on Rent Pune?',
        answer: 'Yes, all drivers are professionally trained, licensed, and experienced in handling Force Urbania vehicles to ensure safety and comfort.',
    },
    {
        question: 'Can I customize pickup and drop-off locations with Non AC Urbania on Rent Pune?',
        answer: 'Absolutely. Non AC Urbania on Rent Pune allows flexible pickup and drop-off across Pune and nearby areas.',
    },
    {
        question: 'Is Non AC Urbania on Rent Pune available 24x7?',
        answer: 'Yes, Non AC Urbania on Rent Pune operates 24x7 to accommodate travel needs at any time.',
    },
    {
        question: 'Are hygiene and safety standards maintained for Non AC Urbania on Rent Pune?',
        answer: 'Yes, all vehicles are regularly cleaned and maintained, with strict safety protocols followed for every trip.',
    },
    {
        question: 'What payment options are available for Non AC Urbania on Rent Pune?',
        answer: 'Non AC Urbania on Rent Pune accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey to ensure a smooth and stress-free experience.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Sameer Joshi',
        feedback: 'We hired Non AC Urbania on Rent Pune for an outstation trip. The vehicle was spacious, clean, and comfortable. Excellent value for money!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sneha Kulkarni',
        feedback: 'Non AC Urbania on Rent Pune provided great service for our corporate travel. Professional driver and reliable service. Highly recommended!',
        rating: 5,
    },
];
























































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Non AC Urbania on Rent Pune",
  "image": "https://urbaniaonrentpune.in/assets/images/non-ac-urbania-on-rent-pune.jpg",
  "description": "Non AC Urbania on Rent Pune provides budget-friendly, non air-conditioned Force Urbania bus rental services for corporate travel, office trips, marriage events, family tours, airport transfers, and outstation journeys. Chauffeur-driven non AC Urbania buses are available for group travel and economy trips at affordable rates.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "1200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/non-ac-urbania-on-rent-pune"
  }
};





    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Non AC Urbania on Rent Pune | Budget Urbania Bus Hire & Group Travel 
  </title>

  <meta
    name="description"
    content="Book Non AC Urbania on Rent Pune for corporate travel, office trips, marriage events, family tours, airport transfers, and outstation journeys. Budget-friendly non AC Urbania buses with chauffeur-driven service for group travel."
  />

  <meta
    name="keywords"
    content="Non AC Urbania on Rent Pune, Non Air Conditioned Urbania Rental Pune, Budget Urbania Hire Pune, Urbania Non AC Bus Hire Pune, Affordable Non AC Urbania Pune, Non AC Urbania for Outstation Pune, Non AC Urbania for Office Trips Pune, Non AC Urbania for Marriage Events Pune, Economy Urbania Rental Pune, Low Cost Urbania Hire Pune, Chauffeur Driven Non AC Urbania Pune, Non AC Urbania Group Travel Pune, Best Non AC Urbania Rental Pune, Non AC Urbania Bus Hire Pune, Value Urbania Hire Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/29.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Nonacurbaniaonrentinpune;